export default __webpack_public_path__ + "static/media/ui_tap-variant-03.0a405efd.wav";